import 'whatwg-fetch'
import 'babel-polyfill'
import 'es6-promise/auto'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import { router, store, i18n } from './allotment'
import App from './App.vue'
import './components'

window._AMapSecurityConfig = { securityJsCode: '7cb1d7ffccd73f31512b43bded3f98b0' }
Vue.config.productionTip = false
new Vue({ router, store, i18n, render: h => h(App) }).$mount('#app')
